import { render, staticRenderFns } from "./PreGameCountdown.vue?vue&type=template&id=4491faa8&"
import script from "./PreGameCountdown.vue?vue&type=script&lang=js&"
export * from "./PreGameCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4491faa8')) {
      api.createRecord('4491faa8', component.options)
    } else {
      api.reload('4491faa8', component.options)
    }
    module.hot.accept("./PreGameCountdown.vue?vue&type=template&id=4491faa8&", function () {
      api.rerender('4491faa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PreGameCountdown.vue"
export default component.exports